import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';

import { PortalRoutes } from '@app/app-routing.module';
import { PopupsService } from '@voyagu/portal-design-system';
import { referralInitials } from '@app/services/referral-program/referral-detail-timeline.util';
import {
  ReferralProgramLoadState,
  ReferralProgramService,
} from '@app/services/referral-program/referral-program.service';
import {
  referralDisplayStatusLabel,
  showDaysLeftToBook,
} from '@app/services/referral-program/referrals-page.util';
import {
  PortalReferralDisplayStatus,
  PortalReferralListItemNode,
  PortalReferralProgramNode,
} from '@app/services/api/api.types';

@Component({
  selector: 'referrals-page',
  templateUrl: './referrals-page.component.html',
  styleUrls: ['./referrals-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralsPageComponent implements OnInit {
  PortalRoutes = PortalRoutes;
  referralDisplayStatusLabel = referralDisplayStatusLabel;
  showDaysLeftToBook = showDaysLeftToBook;
  PortalReferralDisplayStatus = PortalReferralDisplayStatus;

  loadState$: Observable<ReferralProgramLoadState>;

  selectedReferral: PortalReferralListItemNode | null = null;
  referralInitials = referralInitials;

  @ViewChild('referralDetailTemplate') referralDetailTemplate: TemplateRef<unknown>;

  constructor(
    private referralProgramService: ReferralProgramService,
    private changeDetectorRef: ChangeDetectorRef,
    private popupsService: PopupsService,
  ) {}

  ngOnInit() {
    this.loadState$ = this.referralProgramService.getState();
    this.referralProgramService.load(true);
  }

  retry() {
    this.referralProgramService.reload();
  }

  openReferralDetail(referral: PortalReferralListItemNode) {
    this.selectedReferral = referral;
    this.popupsService.showModal(this.referralDetailTemplate);
    this.changeDetectorRef.markForCheck();
  }

  closeReferralDetail() {
    this.popupsService.hideLast();
    this.selectedReferral = null;
  }

  trackReferral(_index: number, item: PortalReferralListItemNode) {
    return item.id;
  }

  isReadyState(
    state: ReferralProgramLoadState | null | undefined,
  ): state is { status: 'ready'; data: PortalReferralProgramNode } {
    return state?.status === 'ready';
  }
}
